export const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1IjoiYnJpZ2h0bGkxMjMiLCJhIjoiY2sxNWFsNjZ3MDA4bjNobzh0eXYycDl5NSJ9.MV-auFFvkDXonPcLy7o9aQ';